<!-- src/app/companies/companies-list/companies-list.component.html -->
<main class="mx-auto w-full md:w-[768px] lg:w-[1024px] xl:w-[1280px] px-5 my-10 mb-15">

    <!-- Breadcrumbs -->
    <nav class="flex items-center gap-2 text-sm text-gray-500 mb-6">
      <a routerLink="/" class="hover:text-gray-800 transition-colors">Home</a>
      <span>/</span>
      <span class="text-gray-800 font-medium">Companies</span>
    </nav>
  
    <!-- Page Header -->
    <div class="flex flex-col gap-3 mb-7">
      <h1 class="text-4xl font-bold leading-tight text-gray-900 m-0">Companies</h1>
      <p class="text-gray-500 text-base m-0">
        Browse active companies and learn more about their opportunities.
      </p>
    </div>

     <!-- Ad Slot — Above Search Bar -->
   <div class="mb-4">
    <app-ad-slot [slotUrl]="adSlotUrl" />
   </div>
  
    <!-- Filter Form -->
    <form
      (ngSubmit)="onSearch()"
      class="flex flex-wrap gap-3 items-center mb-7 w-full"
    >
      <!-- Search Input -->
      <mat-form-field appearance="outline" class="flex-1 min-w-80">
        <mat-label>Search companies...</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="searchQuery"
          [ngModelOptions]="{ standalone: true }"
          name="q"
        />
        @if (searchQuery()) {
          <button
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Clear search"
            (click)="searchQuery.set('')"
          >
            <mat-icon svgIcon="circle-x"></mat-icon>
          </button>
        }
      </mat-form-field>
  
      <!-- Sort Select -->
      <mat-form-field appearance="outline" class="w-58">
        <mat-label>Sort by</mat-label>
        <mat-select
          [(ngModel)]="sortBy"
          [ngModelOptions]="{ standalone: true }"
          name="sortBy"
          (ngModelChange)="onSortChange()"
        >
          <mat-option value="random">Random Order</mat-option>
          <mat-option value="name">A–Z by Name</mat-option>
        </mat-select>
      </mat-form-field>
  
      <!-- Actions -->
<div class="flex gap-3 items-center self-end mt-[1.25em]">
  <button mat-flat-button type="submit" color="primary">
    Search
  </button>

  @if (hasActiveFilters()) {
    <button
      mat-stroked-button
      type="button"
      (click)="clearFilters()"
    >
      Clear
    </button>
  }
</div>

    </form>
  
    <!-- Loading State -->
    @if (loading()) {
      <div class="flex justify-center items-center py-20">
        <mat-spinner diameter="48" />
      </div>
    }
  
    <!-- Error State -->
    @else if (error()) {
      <p class="text-red-500 text-sm">
        Something went wrong loading companies. Please try again.
      </p>
    }
  
    <!-- Empty State -->
    @else if (!loading() && companies().length === 0) {
      <p class="text-gray-400">No companies found.</p>
    }
  
    <!-- Company Grid -->
    @else {
      <div class="grid gap-2 md:gap-6 items-stretch grid-cols-12">
        @for (company of companies(); track company.name; let i = $index, last = $last) {
          <app-company-card [company]="company" class="col-span-6 lg:col-span-4 xl:col-span-3" />

          <!-- Ad Slot — In-list, every 12 (mobile/tablet) or 24 (desktop) companies -->
          @if (showAdAfter(i, last)) {
            <div class="col-span-12">
              <app-ad-slot [slotUrl]="adSlotUrl" />
            </div>
          }
        }
      </div>
    }

    <!-- Ad Slot — Footer -->
    <div class="mt-10">
      <app-ad-slot [slotUrl]="adSlotUrl" />
    </div>
  
  </main>
  